import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { DataProvider } from '../data/data';
import { ProductProvider } from '../product/product';

import { Storage } from '@ionic/storage';
import { OrderLine } from '../../models/order';

class BasketItem {
  productId: string;
  quantity: number;
}

const KEY = 'BASKET';

@Injectable()
export class BasketProvider {
  basket: Array<BasketItem> = new Array<BasketItem>();

  public subPrice: number = 0;
  public subTotal: number = 0;

  constructor(private storage: Storage, private productProvider: ProductProvider) {
    this.storage.get(KEY).then(basket => {
      if (basket) {
        this.basket = basket;
        this.update();
      }
    });
  }

  /**
   * Returns basket items as OrderLine Array.
   */
  public getOrderLines(): Array<OrderLine> {
    var orderLines = new Array<OrderLine>();
    this.basket.forEach(x => {
      var l = new OrderLine();
      l.product_id = x.productId;
      l.quantity = x.quantity;
      orderLines.push(l);
    });
    return orderLines;
  }

  private save() {
    this.storage.set(KEY, this.basket);
  }

  private update() {
    this.updatePriceSubtotal();
    this.updateSubtotal();
  }

  /**
  * Increases the basket quantity of the specified product with one.
  */
  public increaseProductQuantity(productId: string) {
    var item = this.getBasketItem(productId);
    item.quantity++;
    this.save();
    this.update();
  }

  /**
  * Decreases the basket quantity of the specified product with one.
  */
  public decreaseProductQuantity(productId: string) {
    var item = this.getBasketItem(productId);
    item.quantity--;
    this.save();
    this.update();
  }

  /**
  * Removes the specified product from the basket.
  */
  public removeBasketItem(productId: string) {
    var item = this.getBasketItem(productId);
    if (item) {
      this.basket = this.basket.filter(x => x != item);
      this.save();
    }
    this.update();
  }

  /**
   * Removes all items from basket.
   */
  public clearBasket() {
    this.basket = this.basket.filter(x => false);
    this.save();
    this.update();
  }

  /**
  * Returns the basket item for the specified product, and creates a new one
  * if none exists.
  */
  private getBasketItem(productId: string): BasketItem {
    var item = this.basket.find(x => x.productId == productId);
    if (!item) {
      item = new BasketItem();
      item.productId = productId;
      item.quantity = 0;
      this.basket.push(item);
    }
    return item;
  }

  /**
  * Sets the specified quantity for the specified product.
  */
  public setProductQuantity(productId: string, quantity: number) {
    var item = this.getBasketItem(productId);
    item.quantity = quantity;
    this.save();
    this.update();
  }

  /**
  * Returns the quantity for the specified product.
  */
  public getProductQuantity(productId: string): number {
    var x = this.basket.find(x => x.productId == productId);
    if (x) {
      return x.quantity;
    }
    return 0;
  }

  /**
  * Returns the total quantity as a string.
  */
  private async updateSubtotal() {
    var total = 0;
    this.basket.forEach(x => {
      total = +total + +x.quantity;
    });
    this.subTotal = total;
  }

  /**
  * Returns the total price as a string with 2 decimals.
  */
  private async updatePriceSubtotal() {
    var total = 0;
    for (let i = 0; i < this.basket.length; i++) {
      var p = await this.productProvider.getProduct(this.basket[i].productId);
      if (p) {
        total = +total + +(p.price_excluding_vat * this.basket[i].quantity);
      }
    }
    this.subPrice = total;
  }
}



// WEBPACK FOOTER //
// ./src/providers/basket/basket.ts